module.exports = __webpack_public_path__ + "img/ZNZD.cccba0ee.png";